import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UploadDocPopUp from "../chatBox/uploadDocPopUp";
import {
  postSendMessageRequest,
  postAllMessageRequest,
} from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import { DELETE_MESSAGE_DATA } from "../../common/constants/ApplicationUrl";
import api from "../../common/dependencies/utils/Api";
import swal from "sweetalert";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import Draggable from "react-draggable";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import SendIcon from "@material-ui/icons/Send";
import Select from "react-select";
import ReactHtmlParser from "react-html-parser";
function ChatBoxModal(props) {
  const {
    postSendMessageRequest,
    postAllMessageRequest,
    getChatListData,
    receiverInfo,
  } = props;
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [approvaloption, setApprovalOption] = useState("");
  const [action, setAction] = useState();
  const [submitData, setSubmitData] = useState();
  const [messageData, setMessageData] = useState("");
  const [fileData, setFileData] = useState("");
  const history = useHistory();
  const messagesEndRef = useRef(null);
  const [cohortListToggle, setCohortListToggle] = useState(false);
  const [cohortSenderName, setCohortSenderName] = useState("");
  const [filterDropName, setFilterDropName] = useState(false);
  const [cohortNameList, setCohortNameList] = useState([]);
  const MIN_TEXTAREA_HEIGHT = 100;
  const MAX_TEXTAREA_HEIGHT = 120;
  const textareaRef = React.useRef(null);
  const [value, setValue] = React.useState("");
  const onChange = (event) => {
    setValue(event.target.value);
    setMessageData(event.target.value);
  };

  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const deleteapiCall = (id) => {
    api
      .POST(DELETE_MESSAGE_DATA, {
        id: id,
        senderId: LoginUser?.id,
      })
      .then((res) => {
        if (res.status == 200) {
          //   setTimeout(() => {
          //   swal("Your Message has been deleted!", {
          //     icon: "success",
          //   });
          // }, 500);
        } else {
          swal("Delete operation unsuccessfull");
        }
      });
  };

  const handleDelete = (id) => {
    swal("Are you sure?", "Do you want to delete this message?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          deleteapiCall(id);
          setTimeout(() => {
            getChatData();
          }, 300);
        } else {
          swal("Delete operation cancelled");
        }
      })

      .catch((err) => {});
  };
  const customStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      // width: 200,
      minWidth: "100%",
      fontSize: "14px",
    }),
    container: (provided) => ({
      ...provided,
      width: 200,
      marginLeft: 10,
      fontSize: 18,
    }),
  };
  React.useLayoutEffect(() => {
    try {
      // Reset height - important to shrink on delete
      textareaRef.current.style.height = "inherit";
      // Set height
      textareaRef.current.style.height = `${Math.max(
        textareaRef.current.scrollHeight,
        MIN_TEXTAREA_HEIGHT
      )}px`;
    } catch (error) {}
  }, [messageData]);

  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const clickOnClose = () => {
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
  };
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [getChatListData]);
  const getChatData = () => {
    let params = {
      senderId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      //   receiverId: window?.receiverId,
      receiverId: cohortListToggle
        ? cohortSenderName?.value
        : props?.receiverId,
      id: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,

      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 50,
        sortField: "createdDate",
        sortOrder: "DESC",
        id: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      },
    };
    if (props?.receiverId) {
      postAllMessageRequest(params);
    }
    setTimeout(() => {
      scrollToBottom();

      // let div = document.getElementById('messageBody');
      // div.lastElementChild.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };
  const getChatDataName = (receiver) => {
    let params = {
      senderId: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      //   receiverId: window?.receiverId,
      receiverId: receiver,
      id: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,

      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 50,
        sortField: "createdDate",
        sortOrder: "DESC",
        id: JSON.parse(localStorage.getItem("SavedLoggedInData"))?.id,
      },
    };
    if (props?.receiverId) {
      postAllMessageRequest(params);
    }
    setTimeout(() => {
      scrollToBottom();

      // let div = document.getElementById('messageBody');
      // div.lastElementChild.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };
  useEffect(() => {
    getChatData();
    scrollToBottom();
  }, []);
  useEffect(() => {
    getChatData();
    scrollToBottom();
  }, [cohortListToggle ? cohortSenderName.value : props.receiverId]);
  useEffect(() => {
    const interval = setInterval(() => {
      getChatData();
      scrollToBottom();
    }, 10000);
    // setTimeout(()=>{
    //   getChatData();
    // },1000)
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {}, [fileData]);
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };

    if (newFormData?.uploadResume !== null) {
    }
  };
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const handleSubmitMessage = () => {
    const formData = new FormData();
    if (messageData === "") {
    }
    if (fileData === "") {
    }
    if (cohortListToggle) {
      let testData = [];
      if (cohortSenderName?.label === "All") {
        cohortNameList.forEach((element) => {
          if (element.label !== "All") {
            testData.push(element.value);
          }
        });

        let params = {
          senderId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          senderName: JSON.parse(localStorage.getItem("SavedLoggedInData"))
            .name,
          receiverId: "",
          message: {
            commentByUserId: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).id,
            commentedByUserRole: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).role,
            text: messageData,
          },
          taggingList: [...testData],
          allExpertTag: false,
          allStudentTag: false,
        };
        formData.append("message", JSON.stringify(params));
        formData.append("commentFile", fileData?.uploadResume);
        setMessageData("");
        setFileData("");
        postSendMessageRequest(formData);
      } else {
        let params = {
          senderId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          senderName: JSON.parse(localStorage.getItem("SavedLoggedInData"))
            .name,
          //   receiverId: window?.receiverId,
          receiverId: cohortSenderName?.value,
          message: {
            commentByUserId: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).id,
            commentedByUserRole: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).role,
            text: messageData,
          },
          //   taggingList: [window?.receiverId],
          taggingList: [cohortSenderName?.value],
          allExpertTag: false,
          allStudentTag: false,
        };
        formData.append("message", JSON.stringify(params));
        formData.append("commentFile", fileData?.uploadResume);
        setMessageData("");
        setFileData("");
        postSendMessageRequest(formData);
      }

      setTimeout(() => {
        getChatData();
      }, 300);
    } else {
      if (messageData !== "" || fileData !== "") {
        let params = {
          senderId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          senderName: JSON.parse(localStorage.getItem("SavedLoggedInData"))
            .name,
          //   receiverId: window?.receiverId,
          receiverId: props?.receiverId,
          message: {
            commentByUserId: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).id,
            commentedByUserRole: JSON.parse(
              localStorage.getItem("SavedLoggedInData")
            ).role,
            text: messageData,
          },
          //   taggingList: [window?.receiverId],
          taggingList: [props?.receiverId],
          allExpertTag: false,
          allStudentTag: false,
        };
        formData.append("message", JSON.stringify(params));
        formData.append("commentFile", fileData?.uploadResume);

        setMessageData("");
        setFileData("");
        postSendMessageRequest(formData);
        setTimeout(() => {
          getChatData();
        }, 300);
      }
    }
  };
  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0,
      y: 0,
    },
    controlledPosition: {
      x: -400,
      y: 200,
    },
  });

  const handleDrag = (e, ui) => {
    const { x, y } = state.deltaPosition;
    setState({
      deltaPosition: {
        x: x + ui.deltaX,
        y: y + ui.deltaY,
      },
    });
  };

  const handleStart = () => {
    setState({ activeDrags: ++state.activeDrags });
  };

  const handleStop = () => {
    setState({ activeDrags: --state.activeDrags });
  };
  const onDrop = (e) => {
    setState({ activeDrags: --state.activeDrags });
    if (e.target.classList.contains("drop-target")) {
      // alert("Dropped!");
      e.target.classList.remove("hovered");
    }
  };
  const onDropAreaMouseEnter = (e) => {
    if (state.activeDrags) {
      e.target.classList.add("hovered");
    }
  };
  const onDropAreaMouseLeave = (e) => {
    e.target.classList.remove("hovered");
  };

  // For controlled component
  const adjustXPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { x, y } = state.controlledPosition;
    setState({ controlledPosition: { x: x - 10, y } });
  };

  const adjustYPos = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { controlledPosition } = state;
    const { x, y } = controlledPosition;
    setState({ controlledPosition: { x, y: y - 10 } });
  };

  const onControlledDrag = (e, position) => {
    const { x, y } = position;
    setState({ controlledPosition: { x, y } });
  };

  useEffect(() => {
    if (
      receiverInfo?.cohortAdminId !== undefined &&
      receiverInfo?.cohortAdminId !== null &&
      receiverInfo?.cohortAdminId !== ""
    ) {
      setCohortListToggle(true);
      setCohortNameList((cohortNameList) => [
        ...cohortNameList,
        {
          value: "All",
          label: "All",
        },
      ]);
      setCohortNameList((cohortNameList) => [
        ...cohortNameList,
        {
          value: receiverInfo?.startup?.id,
          label: receiverInfo?.startup?.applicant_name,
        },
      ]);
      setCohortNameList((cohortNameList) => [
        ...cohortNameList,
        {
          value: receiverInfo?.mentor?.id,
          label: receiverInfo?.mentor?.applicant_name,
        },
      ]);
    } else {
      setCohortListToggle(false);
    }
    //  if(chortListToggle){

    //  }
    //  else{

    //  }
    let name = {
      value: receiverInfo?.startup?.id,
      label: receiverInfo?.startup?.applicant_name,
    };
    setCohortSenderName(name);
  }, [receiverInfo]);
  const chatParesedData = (str) => {
    //   const RE_URL = /\w+:\/\/\S+/g;
    //   let match;
    // const results = [];
    // let lastIndex = 0;
    // while (match = RE_URL.exec(str)) {
    //   const link = match[0];
    //   if (lastIndex !== match.index) {
    //     const text = str.substring(lastIndex, match.index);
    //     results.push(
    //       <span key={results.length}>{text}</span>,
    //     );
    //   }
    //   results.push(
    //     <a key={results.length} href={link} target="_blank">{link}</a>
    //   );
    //   lastIndex = match.index + link.length;
    // }
    // if (results.length === 0) {
    //   return str;
    // }
    // if (lastIndex !== str.length) {
    //   results.push(
    //     <span key={results.length}>{str.substring(lastIndex)}</span>,
    //   );
    // }
    // return results;
    const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
    let testReg = str.toString().replace(reg, "<a href='$1$2'>$1$2</a>");
    let htmlParser = ReactHtmlParser(testReg);
    return htmlParser;
  };

  return (
    <>
      <Draggable
        axis="x"
        handle=".handle"
        defaultPosition={{ x: 0, y: 0 }}
        position={null}
        grid={[25, 25]}
        scale={1}
        onStart={handleStart}
        onDrag={handleDrag}
        onStop={handleStop}
      >
        <div className="modal-dialog modal-dialog-centered">
          <Modal
            size="lg"
            show={props.modalVisibility}
            onHide={() => props.setModalVisibility(false)}
            aria-labelledby="example-modal-sizes-title-lg"
            style={{
              borderRadius: "7px",
              backgroundColor: "transparent",
            }}
            className="myModalChat"
          >
            <Modal.Body className="modalBodyFix2">
              <>
                <div
                  style={{
                    position: "relative",
                    top: "2rem",
                    marginBottom: "20px",
                  }}
                  className="messageBox row themessageboxhello"
                >
                  <div className="messageTitle2">
                    <div style={{ width: "90%" }}>
                      {cohortListToggle ? (
                        <div
                          style={{
                            marginRight: "1rem",
                            cursor: "pointer",
                            display: "flex",
                          }}
                          onClick={() => {
                            setFilterDropName(true);
                          }}
                        >
                          <div>{cohortSenderName?.label}</div>
                          <div
                            style={{
                              position: "relative",
                              marginLeft: "0.25rem",
                              marginTop: "0.25rem",
                            }}
                          >
                            <div className="tooltip7">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                fill="currentColor"
                                class="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                              <span
                                id="profileDrop"
                                className="tooltiptext7-profile"
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "0.15rem",
                                }}
                              >
                                <div className="col-md-12 animated fadeIn">
                                  <div
                                    className="card"
                                    style={{ height: "auto" }}
                                  >
                                    <div
                                      className="card-body2"
                                      style={{
                                        background: "#E6E7E8",
                                        height: "auto",
                                        position: "relative",
                                      }}
                                    >
                                      <div
                                        className="d-flex justify-content-center"
                                        style={{
                                          maxHeight: "285px",
                                          flexDirection: "column",
                                        }}
                                      >
                                        {cohortNameList.map((ele, index) => {
                                          return (
                                            <div
                                              style={{
                                                maxHeight: "auto",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <h5
                                                className={
                                                  ele.value ===
                                                  cohortSenderName?.value
                                                    ? "thm-language-active"
                                                    : "thm-language"
                                                }
                                                // className="thm-language-active"
                                                onClick={() => {
                                                  setCohortSenderName(ele);
                                                  setTimeout(() => {
                                                    getChatDataName(ele.value);
                                                  }, 300);
                                                  // changeLanguagePortal("en");
                                                  // setLanguage("en");
                                                }}
                                                title=""
                                              >
                                                {ele.label}
                                              </h5>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                        </div>
                      ) : receiverInfo?.applicant_name === undefined ? (
                        receiverInfo?.mentorName
                      ) : (
                        receiverInfo?.applicant_name
                      )}
                    </div>

                    <div className="newuserTooltip">
                      <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleClose}
                      />
                      <span
                        className="tooltiptext  close-window"
                        style={{ left: "-116px", top: "2px", width: "120px" }}
                      >
                        Close Window
                      </span>
                    </div>
                  </div>
                  <div className="messageBody2">
                    {getChatListData && getChatListData?.length > 0 ? (
                      getChatListData.map((chatItem, index) =>
                        chatItem.message.commentByUserId ==
                        props?.receiverInfo?.id ? (
                          <>
                            <br />
                            <div className="messageTimeshow">
                              {moment(chatItem.message.createdDate).format(
                                "DD-MM-YYYY"
                              )}
                            </div>
                            <div className="senderMessageBox row">
                              <div className="messageTextContent">
                                {chatParesedData(chatItem.message.text)}
                                <br />

                                {chatItem?.message?.filePath !== null && (
                                  <div
                                    className="file-name fileChatPositionFix"
                                    style={{ float: "left" }}
                                  >
                                    <a
                                      href={chatItem.message.filePath}
                                      target="_blank"
                                      className="messageDocumentContent2"
                                    >
                                      View File
                                    </a>
                                  </div>
                                )}
                                <div className="messageTime">
                                  {moment(chatItem.message.createdDate).format(
                                    "hh:mm a"
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <br />
                            <div className="messageTimeshow2">
                              <div
                                className="d-flex justify-content-end"
                                style={{ width: "100%" }}
                              >
                                {moment(chatItem.message.createdDate).format(
                                  "DD-MM-YYYY"
                                )}
                              </div>
                            </div>
                            <div className="receiverMessageBox row deletepopup2">
                              <div>
                                <div className="messageTextContent2">
                                  {chatParesedData(chatItem.message.text)}
                                  {/* {(ReactHtmlParser(chatItem.message.text))} */}
                                </div>

                                {chatItem?.deleted == false &&
                                chatItem?.message?.filePath != null ? (
                                  <div className="d-flex messageTextContent2">
                                    <div className="file-name sendDocumentPositionFix">
                                      <a
                                        href={
                                          `${process.env.REACT_APP_DOC_URL}${chatItem.message.filePath}`
                                          // "https://uat-nmp-api.startupindia.gov.in/v1/document/" +
                                          // chatItem.message.filePath
                                        }
                                        target="_blank"
                                        className="messageDocumentContent2"
                                      >
                                        View File
                                      </a>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              {chatItem?.deleted === false ? (
                                <DeleteIcon
                                  className="showbelowdata2"
                                  onClick={() => handleDelete(chatItem?.id)}
                                />
                              ) : (
                                ""
                              )}
                              <div className="messageTime2">
                                {moment(chatItem.message.createdDate).format(
                                  "hh:mm a"
                                )}
                              </div>
                            </div>
                            <div ref={messagesEndRef} />
                          </>
                        )
                      )
                    ) : (
                      <>
                        <div className="emptyChatFix">
                          No Messages here yet ...
                          <br />
                          Send your first Message
                        </div>
                      </>
                    )}
                  </div>
                  <div className="messageFooter">
                    <div class="input-group mt-3 mb-3">
                      <textarea
                        // onChange={onChange}
                        className="form-control messageInputSend"
                        onChange={onChange}
                        ref={textareaRef}
                        placeholder="Type here"
                        style={{
                          minHeight: MIN_TEXTAREA_HEIGHT,
                          maxHeight: MAX_TEXTAREA_HEIGHT,
                          lineHeight: "15px",
                          borderRadius: "2px",
                          padding: "7px",
                          resize: "none",
                          border: "1px solid white",
                        }}
                        value={messageData}
                        onKeyDown={(e) => {
                          if (e.code === "Enter") {
                            e.preventDefault();
                            handleSubmitMessage();
                          }
                        }}
                      />

                      <div class="input-group-append">
                        <div className="newuserTooltip">
                          <div className="col-2 outerUploadBox">
                            <button
                              onClick={clickonFileinput}
                              className="newUploadBtn2"
                            >
                              <AttachFileIcon
                                style={{
                                  transform: "rotate(-40deg)",
                                  color: "white",
                                }}
                              />
                            </button>

                            <div className="fileupload-resume-startup2">
                              <input
                                className="resume-upload"
                                type="file"
                                id="fileUpload-resume"
                                required
                                name="uploadResume"
                                onChange={handleInputChange}
                                style={{ display: "none" }}
                                accept=" audio/* ,video/* ,image/*,.xlsx,.xls,.doc, .docx,.pdf"
                                // accept="image/png, image/jpeg,application/pdf,video/mp4"
                                // accept="application/pdf, application/vnd.ms-excel"
                              />
                            </div>
                            <span
                              className="tooltiptext  close-summaryw"
                              style={{
                                left: "-197px",
                                top: "5px",
                                width: "186px",
                                height: "48px",
                              }}
                            >
                              Supported files format pdf, jpeg, png only upto
                              2MB
                            </span>
                          </div>
                        </div>

                        <div className="newuserTooltip">
                          <span
                            class="input-group-text sendMsgBtn"
                            style={{ cursor: "pointer" }}
                            onClick={handleSubmitMessage}
                          >
                            <SendIcon
                              style={{
                                transform: "rotate(-40deg)",
                                color: "white",
                                width: "95%",
                              }}
                            />
                          </span>
                          <span
                            className="tooltiptext close-summaryw close-summary12"
                            style={{
                              left: "-122px",
                              top: "12px",
                              width: "115px",
                            }}
                          >
                            Send Message
                          </span>
                        </div>
                      </div>
                    </div>
                    {fileData &&
                      fileData?.uploadResume !== undefined &&
                      fileData?.uploadResume !== null && (
                        <div className="">
                          <div
                            className="file-name fileChatPositionFix"
                            style={{ float: "left" }}
                          >
                            {fileData?.uploadResume?.name}{" "}
                            <span
                              style={{ marginLeft: "10px", cursor: "pointer" }}
                              onClick={() => removeFile("uploadResume")}
                            >
                              {" "}
                              X{" "}
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                {showSubmitAction ? (
                  <UploadDocPopUp
                    isOpen={showSubmitAction}
                    className={"form-submit-modal"}
                    onClose={clickOnClose}
                    action={action}
                    submitData={submitData}
                    formName={"mentor-form"}
                    setfileDataParent={setFileData}
                  />
                ) : (
                  ""
                )}
              </>
            </Modal.Body>
          </Modal>
        </div>
      </Draggable>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getChatListData: state.StartUpReducer.allIMMessages.data,
  };
};

export default connect(mapStateToProps, {
  postSendMessageRequest,
  postAllMessageRequest,
})(withRouter(ChatBoxModal));
